import React, { useEffect } from 'react';
import { useNavigate } from 'src/utils/useNavigate';
import Button from 'src/components/Button';
import ContentLayout from 'src/components/ContentLayout';
import Text from 'src/components/Text';
import routes from 'src/constants/routes';
import styles from './styles.module.scss';
import useApplicationAllowedBanks from 'src/dataHooks/useApplicationAllowedBanks';

const NotPartnerBanks: React.FC = () => {
  const navigate = useNavigate();
  const { fetchAllowedBanks, allowedBanks } = useApplicationAllowedBanks();
  const otherBanks = allowedBanks?.otherBanks || [];
  
  useEffect(() => {
    fetchAllowedBanks();
  }, []);

  const handleClick = () => {
    navigate(routes.main);
  };

  return (
    <ContentLayout size="medium">
      <Text type="h2" className={styles['title']}>Список банков</Text>
      <Text type="p" muted italic small>
        Для заключения договора на СБП с банком из этого списка, нужно обратиться непосредственно в банк. Выполнение операций
        через СБП с помощью токенов, которые были получены в Агенте 1С:СБП, возможно только при наличии действующего{' '}
        <a href="https://portal.1c.ru/applications/1C-SBP#prices" target="_blank">
          платного тарифа
        </a>
        .
      </Text>
      <ul>
        {otherBanks.map((bank: any) => (
          <li key={bank.name}>
            <Text type="span" small>{bank.name}</Text>
          </li>
        ))}
      </ul>
      <div className={styles['button-wrapper']}>
        <Button variant="outlined" onClick={handleClick}>
          На Главную
        </Button>
      </div>
    </ContentLayout>
  );
};

export default NotPartnerBanks;
